import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import { getFilter } from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';

const options = [
  {
    label: 'No Underlying',
    value: null,
  },
  {
    label: 'BANKNIFTY',
    value: 'BANKNIFTY',
  },
  {
    label: 'NIFTY',
    value: 'NIFTY',
  },
  {
    label: 'FINNIFTY',
    value: 'FINNIFTY',
  },
  {
    label: 'SENSEX',
    value: 'SENSEX',
  },
  {
    label: 'MIDCPNIFTY',
    value: 'MIDCPNIFTY',
  },
  {
    label: 'BANKEX',
    value: 'BANKEX',
  },
];

const ViewUnderlying = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.underlyingSymbols ? true : false;

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={options}
          viewsFilter={viewsFilter}
          fieldName="underlyingSymbols"
          title="Filter Underlying:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewUnderlying;
